import * as Models from "../ts/rlAdmin.models";
import { RLBaseService } from "./rl-base-service";

export class FinancialPeriodService extends RLBaseService {
	static $inject = ["$resource"];

	constructor(private $resource: ng.resource.IResourceService) {
		super($resource);
	}

	getWorkflowLockedAction(workflowID: number) {
		var data = { workflowID: workflowID };
		return this.toRLService<Models.IDataResponse<number>>("/api/financialperiod/getworkflowlockedaction").get(data).$promise;
	}

	getWorkflowConfigActionsWithLockedStatus(workflowID: number, charTypeID: number) {
		var data = {
			workflowID: workflowID,
			charTypeID: charTypeID
		};
		return this.toRLService<Models.IWFActionConfig>("/api/financialperiod/getworkflowconfigactionswithlockedstatus").query(data).$promise;
	}

	createWorfklowLockedAction(workflowID: number, actionID: number) {
		var data = {
			workflowID: workflowID,
			actionID: actionID			
		};
		return this.toRLService<Models.IDataResponse<number>>("/api/financialperiod/createworkflowlockedaction").post(data).$promise;
	}

	deleteWorkflowLockedAction(workflowID: number) {
		var data = {
			workflowID: workflowID
		};
		return this.toRLService<Models.IDataResponse<number>>("/api/financialperiod/deleteworkflowlockedaction").post(data).$promise;
	}

	updateWorkflowLockedAction(workflowID: number, actionID: number) {
		var data = {
			workflowID: workflowID,
			actionID: actionID
		};
		return this.toRLService<Models.IDataResponse<number>>("/api/financialperiod/updateworkflowlockedaction").post(data).$promise;
	}

	updateAmountToLockedStatusByDueDate(period: Models.IFinancialPeriod) {
		return this.toRLService<Models.IDataResponse<number>>("/api/financialperiod/updateamountstolockedstatusbyduedate").post(period).$promise;
	}

	getFinancialPeriods(page: number, pageSize: number, sortField: string, sortDir: number) {
		var data = {
			page,
			pageSize,
			sortField,
			sortDir
		};
		return this.toRLService<Models.IPagedDataResponse<Models.IFinancialPeriod[]>>("/api/financialperiod/financialperiods").get(data).$promise;
	}

	createFinancialPeriod(period: Models.IFinancialPeriod) {
		var data = {
			period
		}
		return this.toRLService<Models.IDataResponse<boolean>>("/api/financialperiod/createfinancialperiod").post(period).$promise;
	}

	updateFinancialPeriod(period: Models.IFinancialPeriod) {
		var data = {
			period
		}
		return this.toRLService<Models.IDataResponse<boolean>>("/api/financialperiod/updatefinancialperiod").post(period).$promise;
	}

	deleteFinancialPeriod(period: Models.IFinancialPeriod) {
		var data = {
			period
		}
		return this.toRLService<Models.IDataResponse<boolean>>("/api/financialperiod/deletefinancialperiod").post(period).$promise;
	}

	validateFinancialPeriods() {
		return this.toRLService<Models.IDataResponse<string[]>>("/api/financialperiod/validatefinancialperiod").get().$promise;
	}
}
